module.exports = __webpack_public_path__ + "static/media/About_Page_Header.a5efb5ba.jpg";